import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'map',
    standalone: true
})
export class MapPipe<T> implements PipeTransform {
  transform(items: T[], callback: (item: T) => T): T[];
  transform(items: T[], key: string): any;
  transform(items: T[], keyOrCallback: ((item: any) => any) | string): any {
    if (!items || !keyOrCallback) {
      return items;
    }
    if (typeof keyOrCallback === 'function') {
      return items.map(keyOrCallback);
    }
    if (typeof keyOrCallback === 'string') {
      return items.map(item => item[keyOrCallback]);
    }
    return items;
  }
}